import React from 'react'
import {makeStyles} from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import ReactPlayer from 'react-player'

const useStyles = makeStyles(theme => ({
  paper: {
    position: 'absolute',
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}))

export default function SimpleModal(props) {
  const classes = useStyles()
  return (
    <div>
      <Modal
        open={props.openModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        onBackdropClick={() => props.handleBackdrop()}
      >
        <div>
          <ReactPlayer
            url={props.url}
            style={{
              position: 'absolute',
              right: '0px',
              top: '220px',
              bottom: '250px',
              left: '395px',
              width: '450px',
              height: '360px',
            }}
          />
        </div>
      </Modal>
    </div>
  )
}
